module.exports = __webpack_public_path__ + "static/img/4.933c17c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/4.png
// module id = /xpA
// module chunks = 0